import React, {useState} from 'react';
import {Image, TouchableOpacity, View} from 'react-native';

import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

import Icon from 'react-native-vector-icons/FontAwesome';
import FastImage from '../../Utils/FastImage';
import {cloudFlareOptimizeImage} from '../../Utils/helpers';
import CustomActivityIndicator from './CustomActivityIndicator';
import {BodyText} from './Text';

export const LocationCard = ({
  title,
  description,
  leftText,
  rightText,
  buttonText,
  color = global?.color?.orange,
  handlePress,
  containerStyle = {},
  imageSource,
  showOverlay,
  overlayText,
}) => {
  const {width} = useWindowDimensionsSafe();
  return (
    <TouchableOpacity
      style={{
        backgroundColor: global?.color?.white,
        borderRadius: 10,
        marginHorizontal: 10,
        marginVertical: 5,
        minHeight: 200,
        position: 'relative',
        width: width - 20,
        ...containerStyle,
      }}
      activeOpacity={0.8}
      disabled={!handlePress}
      onPress={handlePress}>
      {!!imageSource && (
        <View
          style={{
            position: 'relative',
            width: width - 40,
            marginHorizontal: 10,
            marginTop: 10,
            height: 140,
          }}>
          <FastImage
            style={{width: width - 40, height: 140}}
            resizeMode={FastImage?.resizeMode?.cover}
            source={imageSource}
          />
          {!!showOverlay && (
            <View
              style={{
                ...global?.style.fillAbsolute,
                backgroundColor: global?.color?.black_30,
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              {!!overlayText && (
                <BodyText
                  text={overlayText}
                  textStyle={{color: 'white', marginTop: 5}}
                />
              )}
            </View>
          )}
        </View>
      )}

      <View>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
          {!!title && (
            <BodyText
              text={title}
              textStyle={{
                marginVertical: 0,
                color: global?.color?.orange,
                fontSize: 14,
                fontWeight: '700',
              }}
            />
          )}
          {!!buttonText && (
            <View
              style={{
                alignItems: 'center',
                backgroundColor: color,
                borderRadius: 10,
                marginVertical: 5,
                marginRight: 10,
                minWidth: 100,
              }}>
              <BodyText
                text={buttonText}
                textStyle={{
                  borderRadius: 10,
                  color: global?.color?.white,
                  fontSize: 12,
                  fontWeight: '700',
                  marginBottom: 3,
                  marginTop: 2,
                }}
              />
            </View>
          )}
        </View>
        {!!description && (
          <BodyText
            text={
              description?.length > 60
                ? `${description.substring(0, 160)}...`
                : description
            }
            textStyle={{
              marginTop: 5,
              marginBottom: 10,
              fontSize: 14,
            }}
          />
        )}
      </View>
      <View style={{flexDirection: 'row', justifyContent: 'space-between'}}>
        {!!leftText && (
          <BodyText
            text={leftText}
            textStyle={{
              marginVertical: 5,
              fontSize: 14,
              color: global?.color?.gray2,
            }}
          />
        )}
        {!!rightText && (
          <BodyText
            text={rightText}
            textStyle={{
              marginVertical: 5,
              fontSize: 14,
              color: global?.color?.gray2,
            }}
          />
        )}
      </View>
    </TouchableOpacity>
  );
};

export const PassportHeader = ({
  title,
  subTitle,
  imageSource,
  headerHeight = 160,
}) => {
  const {width} = useWindowDimensionsSafe();
  return (
    <View style={{position: 'relative'}}>
      <FastImage
        style={{width, height: headerHeight, position: 'absolute'}}
        source={imageSource}
        resizeMode={FastImage?.resizeMode?.cover}
      />
      <View
        style={{
          width,
          height: headerHeight,
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: global?.color?.black_30,
        }}>
        <View
          style={{
            borderBottomWidth: 2,
            borderBottomColor: global?.color?.orange,
            paddingBottom: 5,
            marginHorizontal: 40,
          }}>
          <BodyText
            text={title}
            textStyle={{
              color: global?.color?.white,
              textAlign: 'center',
              fontSize: 20,
              lineHeight: 22,
              fontWeight: '700',
            }}
          />
        </View>
        <BodyText
          text={subTitle}
          textStyle={{color: global?.color?.white, fontSize: 12, marginTop: 5}}
        />
      </View>
    </View>
  );
};

export const DealCard = ({
  title,
  titleStyle = {},
  topTitle,
  description,
  buttonText,
  color,
  handlePress,
  containerStyle = {},
  imageSource,
  showOverlay,
  overlayText,
  minHeight = 200,
  allowLongText = false,
  resizeMode = 'cover',
  overlayTextStyle = {},
  overlayTextContainerStyle = {},
  imageContainerStyle = {},
  imageStyle = {},
  testID = 'dealCard',
}) => {
  const {width} = useWindowDimensionsSafe();
  const [errorFallback, setErorFallBack] = useState();
  return (
    <TouchableOpacity
      style={{
        backgroundColor: global?.color?.white,
        borderRadius: 10,
        marginHorizontal: 10,
        marginVertical: 5,
        minHeight,
        position: 'relative',
        width: width - 20,
        ...containerStyle,
      }}
      testID={testID}
      activeOpacity={0.8}
      disabled={!handlePress}
      onPress={handlePress}>
      {!!topTitle && (
        <BodyText
          text={topTitle}
          textStyle={{
            marginTop: 15,
            marginLeft: 10,
            fontWeight: '700',
          }}
        />
      )}
      {!!imageSource && (
        <View
          style={{
            position: 'relative',
            width: width - 40,
            marginHorizontal: 10,
            marginTop: 10,
            height: 140,
            backgroundColor: global?.color?.white1,
            ...imageContainerStyle,
          }}>
          <FastImage
            style={{width: width - 40, height: 140, ...imageStyle}}
            resizeMode={FastImage?.resizeMode?.[resizeMode]}
            source={errorFallback || imageSource}
            onError={() => {
              setErorFallBack(
                cloudFlareOptimizeImage(
                  'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648578460_medium.jpg',
                ),
              );
            }}
          />
          {!!showOverlay && (
            <View
              style={{
                ...global?.style.fillAbsolute,
                backgroundColor: global?.color?.black_30,
                justifyContent: 'center',
                alignItems: 'center',
                ...overlayTextContainerStyle,
              }}>
              {!!overlayText && (
                <BodyText
                  text={overlayText}
                  textStyle={{
                    color: 'white',
                    marginTop: 5,
                    ...overlayTextStyle,
                  }}
                />
              )}
            </View>
          )}
        </View>
      )}

      <View>
        {(!!title || !!buttonText) && (
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
            {!!title && (
              <BodyText
                text={title}
                textStyle={{
                  marginVertical: 0,
                  marginLeft: 10,
                  color: global?.color?.orange,
                  fontSize: 14,
                  fontWeight: '700',
                  marginRight: 5,
                  maxWidth: width - 150,

                  ...titleStyle,
                }}
              />
            )}
            {!!buttonText && (
              <View
                style={{
                  alignItems: 'center',
                  backgroundColor: color,
                  borderRadius: 10,
                  marginVertical: 5,
                  marginRight: 10,
                  minWidth: 100,
                }}>
                <BodyText
                  text={buttonText}
                  textStyle={{
                    borderRadius: 10,
                    color: global?.color?.white,
                    fontSize: 12,
                    fontWeight: '700',
                    marginBottom: 3,
                    marginTop: 2,
                  }}
                />
              </View>
            )}
          </View>
        )}
        {!!description && (
          <BodyText
            text={
              description?.length > 60 && !allowLongText
                ? `${description.substring(0, 160)}...`
                : description
            }
            textStyle={{
              marginTop: 5,
              marginLeft: 10,
              marginBottom: 10,
              fontSize: 14,
            }}
          />
        )}
      </View>
    </TouchableOpacity>
  );
};

export const ChallengeCard = ({
  title,
  icon,
  description,
  iconText,
  completedText,
  iconStyle = {},
  handlePress,
  color = global?.color?.blue,
  completed,
  disabled,
  testID,
}) => {
  const {width} = useWindowDimensionsSafe();
  return (
    <TouchableOpacity
      style={{
        ...global?.style.boxShadow,
        backgroundColor: completed ? global?.color?.teal : color,
        minHeight: 80,
        borderRadius: 10,
        marginHorizontal: 10,
        marginVertical: 5,
        width: width - 20,
        flexDirection: 'row',
      }}
      testID={testID}
      activeOpacity={0.8}
      onPress={handlePress}
      disabled={!!disabled}>
      <View style={{flex: 1, justifyContent: 'space-between'}}>
        <BodyText
          text={!!completed ? `${title} - Completed` : title}
          textStyle={{
            color: global?.color?.white,
            textAlign: 'left',
            marginTop: 10,
            marginLeft: 10,
            fontWeight: '700',
          }}
        />
        <BodyText
          text={description}
          textStyle={{
            color: global?.color?.white,
            textAlign: 'left',
            marginBottom: 10,
            marginLeft: 10,
            fontStyle: 'italic',
          }}
        />
      </View>

      <View
        style={{
          alignItems: 'center',
          backgroundColor: global?.color?.white1,
          justifyContent: 'center',
          width: 80,
        }}>
        {!!icon && (
          <FastImage
            resizeMode={FastImage?.resizeMode?.contain}
            source={icon}
            style={{width: 50, height: 50, ...iconStyle}}
          />
        )}
        {!completed && (
          <BodyText
            text={iconText}
            textStyle={{marginTop: 0, marginHorizontal: 0}}
          />
        )}
        {!!completed && !!completedText && (
          <BodyText
            text={completedText}
            textStyle={{marginTop: 0, marginHorizontal: 0}}
          />
        )}
      </View>
    </TouchableOpacity>
  );
};

export const PhotoTile = ({source, handlePress}) => {
  const {width} = useWindowDimensionsSafe();
  const tileWidth = width - 20;
  return (
    <TouchableOpacity
      style={{
        backgroundColor: global?.color?.white1,
        width: tileWidth,
        height: tileWidth,
        marginVertical: 5,
        marginHorizontal: 10,
        justifyContent: 'center',
        alignItems: 'center',
      }}
      activeOpacity={0.8}
      disabled={!handlePress}
      onPress={handlePress}>
      <CustomActivityIndicator
        size={'small'}
        color={global?.color?.gray3}
        style={{position: 'absolute'}}
      />
      <Image
        source={{uri: source}}
        style={{
          width: tileWidth,
          height: tileWidth,
        }}
      />
    </TouchableOpacity>
  );
};

export const ClassicChallengeCard = ({
  title = '',
  text = '',
  icon,
  label,
  sublabel,
  backgroundColor,
  backgroundUrl,
  handlePress,
  completed,
  completedLabel,
  completedIcon,
  completedIconColor,

  containerStyle = {},
  testID,
}) => {
  const {width} = useWindowDimensionsSafe();
  return (
    <TouchableOpacity
      testID={testID}
      activeOpacity={0.9}
      style={{
        ...global?.style.boxShadow,
        backgroundColor: global?.color?.white,
        minHeight: 80,
        borderRadius: 13,
        marginHorizontal: 10,
        marginVertical: 5,
        width: width - 20,
        flexDirection: 'row',
        position: 'relative',
        ...containerStyle,
      }}
      onPress={handlePress}
      disabled={!handlePress}>
      {!!backgroundUrl && (
        <FastImage
          resizeMode={FastImage?.resizeMode?.cover}
          source={{uri: backgroundUrl}}
          style={{
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            width: 80,
            borderTopLeftRadius: 10,
            borderBottomLeftRadius: 10,
          }}
        />
      )}
      <View
        style={{
          borderTopLeftRadius: 10,
          borderBottomLeftRadius: 10,
          alignItems: 'center',
          backgroundColor: backgroundUrl
            ? null
            : backgroundColor || global?.color?.gray3,
          justifyContent: 'center',
          width: 80,
        }}>
        {!!icon && <Icon name={icon} size={28} color={global?.color?.white} />}
        {!!label && (
          <BodyText
            textStyle={{
              marginTop: 8,
              marginHorizontal: 0,
              color: global?.color?.white,
            }}>
            {label}
          </BodyText>
        )}
        {!!sublabel && (
          <BodyText
            textStyle={{
              marginTop: 2,
              marginHorizontal: 0,
              color: global?.color?.white,
              fontSize: 12,
              lineHeight: 14,
            }}>
            {sublabel}
          </BodyText>
        )}
      </View>
      <View
        style={{
          flex: 1,
          justifyContent: 'space-between',
          paddingVertical: 10,
          position: 'relative',
        }}>
        {!!completedLabel && (
          <View
            style={{position: 'absolute', top: 10, right: completed ? 30 : 5}}>
            <BodyText text={completedLabel} textStyle={{fontWeight: '700'}} />
          </View>
        )}
        {!!completed && (
          <View style={{position: 'absolute', top: 5, right: 5}}>
            <Icon
              name={completedIcon || 'check'}
              size={33}
              color={completedIconColor || global?.color?.brightgreen}
            />
          </View>
        )}
        {!!title && (
          <BodyText
            textStyle={{
              textAlign: 'left',
              marginTop: 10,
              marginLeft: 10,
              marginRight: 50,
              fontWeight: '700',
            }}>
            {title}
          </BodyText>
        )}
        {!!text && (
          <BodyText
            text={text}
            textStyle={{
              textAlign: 'left',
              marginBottom: 10,
              marginLeft: 10,
              marginRight: 35,
            }}
          />
        )}
      </View>
    </TouchableOpacity>
  );
};
